module.exports = __webpack_public_path__ + "img/card-documents-not-submitted-report.3145ca42.svg";